import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-list-search-data-report',
    templateUrl: './list-search-data-report.component.html',
    styleUrls: ['./list-search-data-report.component.scss'],
    standalone: false
})
export class ListSearchDataReportComponent implements OnInit {

  @Input() name: string = '';
  @Input() hideHeader: boolean = false;
  form?: UntypedFormGroup;

  @Output() reportDownload = new EventEmitter<any>();
  
  constructor(private fb: UntypedFormBuilder, ) {

  }
  ngOnInit(): void {
    this.form = this.fb.group({
      dexCode: ['', []],
      clientCode: ['', []],
    });


  }

  sendDownloadButton(){
    let dexCode = this.form?.get('dexCode')?.value
    let clientCode = this.form?.get('clientCode')?.value
    this.reportDownload.emit({values: [dexCode, clientCode]});
  }

}
